import { render, staticRenderFns } from "./PartidaGrid.vue?vue&type=template&id=3b28a438"
import script from "./PartidaGrid.vue?vue&type=script&lang=js"
export * from "./PartidaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports